import { render, staticRenderFns } from "./HedgingCostsOptionsInterbankRatesTableBlock.vue?vue&type=template&id=bd2431cc"
import script from "./HedgingCostsOptionsInterbankRatesTableBlock.vue?vue&type=script&lang=js"
export * from "./HedgingCostsOptionsInterbankRatesTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
